@if (sources()) {
  <div class="playlist-container">
    <h6>{{ title(current()?.url) }}</h6>
    <app-viewer [ref]="current()"
                [autoplay]="autoplay()"
                (playing)="autoplay.set(true)"
                (pausing)="autoplay.set(false)"
                (ended)="next(repeat())" />
    <div class="playlist-controls">
      <button class="previous-track" type="button" (click)="back()">◀️</button>
      <button class="repeat-toggle" type="button" (click)="repeat.set(!repeat())" [class.selected]="repeat()">🔁</button>
      <button class="next-track" type="button" (click)="next()">▶️</button>
    </div>
  </div>
  @if (ref()?.sources?.length) {
    <details open>
      <summary i18n>Playlist</summary>
      <ol class="playlist-menu">
        @for (s of ref()!.sources; track s; let i = $index) {
          <li tabindex="0"
              [class.selected]="s === current()?.url"
              (keydown)="$event.key === 'Enter' && seek(i) || true"
              (click)="seek(i)">{{ title(s) }}</li>
        }
      </ol>
    </details>
  }
} @else {
  <app-loading />
}
